import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';

class UserServiceAbstract {
    constructor() {
        this.isInitialized = false;
        this.initPromise = null;
        // this.init();
    }
    init() {
        this.initPromise = this.retrieveUser();
        this.initPromise.then((user) => {
            this.user = user;
            this.isInitialized = true;
            this.initPromise = null;
        }).catch((err) => {
            console.error(err);
            this.initPromise = null;
        });
    }
    setUser(user) {
        this.user = user;
    }
    getUser(forceReload) {
        return new Promise((resolve, reject) => {
            if (!this.isInitialized) {
                if (!this.initPromise)
                    this.init();
                if (this.initPromise) {
                    this.initPromise.then((user) => {
                        resolve(user);
                    }).catch((err) => {
                        reject(err);
                    });
                    return;
                }
                throw new Error('UserService not initialized');
            }
            if (forceReload) {
                this.retrieveUser(forceReload).then((user) => {
                    this.user = user;
                    resolve(this.user);
                }).catch((err) => {
                    reject(err);
                });
            }
            resolve(this.user);
        });
    }
}

class CompanyServiceAbstract {
    constructor() {
        this.isInitialized = false;
        this.initPromise = null;
        // this.init();
    }
    init() {
        this.initPromise = this.retrieveCompany();
        this.initPromise.then((company) => {
            this.company = company;
            this.isInitialized = true;
        }).catch((err) => {
            console.error(err);
        });
    }
    setCompany(company) {
        this.company = company;
    }
    getCompany(forceReload) {
        return new Promise((resolve, reject) => {
            if (!this.isInitialized) {
                if (!this.initPromise)
                    this.init();
                if (this.initPromise) {
                    this.initPromise.then((company) => {
                        resolve(company);
                    }).catch((err) => {
                        reject(err);
                    });
                    return;
                }
                throw new Error('CompanyService not initialized');
            }
            if (forceReload) {
                this.retrieveCompany(forceReload).then((company) => {
                    this.company = company;
                    resolve(this.company);
                }).catch((err) => {
                    reject(err);
                });
            }
            resolve(this.company);
        });
    }
}

class NgxMareUserModule {
    static forRoot(config) {
        return {
            ngModule: NgxMareUserModule,
            providers: [
                { provide: 'MAREUSERCONFIG', useValue: config },
                config.userService || { provide: UserServiceAbstract, useValue: config.userService },
                config.companyService || { provide: CompanyServiceAbstract, useValue: config.companyService }
            ]
        };
    }
}
NgxMareUserModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgxMareUserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxMareUserModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: NgxMareUserModule });
NgxMareUserModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgxMareUserModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgxMareUserModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

/*
 * Public API Surface of ngx-mare-user
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CompanyServiceAbstract, NgxMareUserModule, UserServiceAbstract };
